import { combineReducers } from 'redux';

import Countries from './countries';
import DisplayedDates from './displayed_dates';
import Docs from './docs';
import Downloads from './downloads';
import Hits from './hits';
import ImpactAggregations from './impact_aggregations';
import Percentiles from './percentiles';
import PreviousDateRangeDownloads from './previous_date_range_downloads';
import PreviousDateRangeHits from './previous_date_range_hits';
import ReaderResearchInterests from './reader_research_interests';
import RefererPairs from './referer_pairs';
import ResearchInterestPercentiles from './research_interest_percentiles';
import SiteSearches from './site_searches';
import Works from './works';

const reducers = {
  Countries,
  DisplayedDates,
  Docs,
  Downloads,
  Hits,
  ImpactAggregations,
  Percentiles,
  PreviousDateRangeDownloads,
  PreviousDateRangeHits,
  ReaderResearchInterests,
  RefererPairs,
  ResearchInterestPercentiles,
  SiteSearches,
  Works,
};

const reducer = combineReducers(reducers);

export { reducer as default, reducer as AnalyticsDashboard };
